import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import { CircularProgress, Box, Typography, Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'

import { announceUserLoggedIn } from '../v2_actions/auth'
import { bpointPayment } from '../v2_actions/bpoint_payment'
import { authenticatedTrolleyList } from '../v2_actions/authenticated_trolley'

const MAX_VERIFICATION_ATTEMPTS = 12
const TIME_BETWEEN_VERIFICATION_ATTEMPTS = 5000

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const BpointCallbackPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { payment_reference, auth_token } = useParams()
  const [ openSnackBar, setOpenSnackBar ] = useState(false)
  const [ alertMessage, setAlertMessage ] = useState("")
  const [ bodyText, setBodyText ] = useState("Verifying payment...")
  let verifyAttempt = 0

  useEffect(() => {
    dispatch(announceUserLoggedIn(auth_token, {})).then(() => {
      tryVerifyPayment(false)
    })
  },[])

  const onMessage = (msg) => {
    setAlertMessage(msg)
    if (msg) {
      setOpenSnackBar(true)
    }
  };

  const tryVerifyPayment = async (has_timed_out) => {
    verifyAttempt++
    if (verifyAttempt !== MAX_VERIFICATION_ATTEMPTS) {
      dispatch(
        bpointPayment.verifyPayment({ payment_ref: payment_reference, has_timed_out: has_timed_out })
      ).then((res) => {
        if (res?.status === 'success') {
          if (res?.results?.payment_status === 'approved') {
            dispatch(authenticatedTrolleyList.resetTrolley())
            navigate('/customer/purchased')
          } else if (res?.results?.payment_status === 'declined') {
            onMessage('Payment declined by provider')
            setTimeout(() => {
              navigate('/customer/events')
            }, TIME_BETWEEN_VERIFICATION_ATTEMPTS)
          } else {
            setTimeout(() => {
              tryVerifyPayment(false)
            }, TIME_BETWEEN_VERIFICATION_ATTEMPTS);
          }
        } else {
          setTimeout(() => {
            tryVerifyPayment(false)
          }, TIME_BETWEEN_VERIFICATION_ATTEMPTS);
        }
      })
    } else {
      setBodyText("We are waiting for the bank to respond, Please don't close your browser. Return in a few minutes to check you have received your photos. Please contact info@bossfotos.com if you are still having problems")
      setTimeout(() => {
        tryVerifyPayment(true)
      }, TIME_BETWEEN_VERIFICATION_ATTEMPTS)
    }
  }
  
  return (
    <>
    <Snackbar
      open={openSnackBar}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={6000}
      onClose={() => setOpenSnackBar(false)}
    >
      <Alert onClose={() => setOpenSnackBar(false)} severity="error">
        { alertMessage }
      </Alert>
    </Snackbar>
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress />
      <Typography variant="body2" style={{ marginTop: 16 }}>
        { bodyText }
      </Typography>
      <Typography variant="body2" style={{ marginTop: 4 }}>
        { `Payment Reference: ${ payment_reference }` }
      </Typography>
    </Box>
    </>
  )
}
